// import userProfile from "../../../src/assets/images/noProfile.png";

import { EditIcon } from "../../../src/assets/icons";
import { useSidebar } from "../../content/SidebarContent";
import PageHeader from "../../components/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetPlanList } from "../../redux/slices.js/plans/plansSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PlanList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsSidebarOpen } = useSidebar();

  const plans = useSelector((state) => state.plans.plans);

  useEffect(() => {
    dispatch(
      reqToGetPlanList({
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  }, []);

  return (
    <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
      <div className="!p-0">
        <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
          <PageHeader
            title="Plan List"
            description="Manage and update plan offerings"
            onOpenSidebar={() => setIsSidebarOpen(true)}
          />

          <div className="flex-1 right-sidebar h-full relative">
            <div
              className={`right-sidebar-contend py-6 px-3 md:p-6 pb-[50px] h-full ${"right-sidebar-tab"}`}
            >
              <div
                className={`dashboard-all-btns mb-10 flex items-center gap-5 flex-wrap justify-between`}
              ></div>
              <div className="overflow-x-auto rounded-md bg-white box-shadow p-5 w-full common-scroll">
                <table className="min-w-[650px]">
                  <thead className="bg-white-vlight p-2 h-[45px]">
                    <tr>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
                        Name
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-80">
                        Price
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
                        Price per User
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
                        Plan Duration
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-150">
                        Allowed Users
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-left w-100">
                        Status
                      </th>
                      <th className="p-2 text-sub_span text-blue !font-extrabold text-right w-100">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {plans?.length === 0 ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center py-6 text-gray-500 font-medium"
                        >
                          No data found.
                        </td>
                      </tr>
                    ) : (
                      plans?.map((user) => (
                        <tr key={user.id} className="">
                          <td className="py-3 px-2">
                            <div className="flex gap-4 items-center">
                              <span className="text-sub_span text-black">
                                {user?.name}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-2">
                            <div className="flex gap-4 items-center">
                              <span className="text-sub_span text-black">
                                ${user?.price ? user?.price : 0}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-2">
                            <div className="flex gap-4 items-center">
                              <span className="text-sub_span text-black">
                                ${user?.price_per_user ? user?.price_per_user : 0}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-2">
                            <div className="text-sub_span text-black">
                              {user?.duration_in_days}
                            </div>
                          </td>
                          <td className="py-3 px-2">
                            <div className="text-sub_span text-black">
                              {/* {user?.tenant?.team_strength} */}
                              {user?.max_active_users}
                            </div>
                          </td>
                          <td className="py-3 px-2">
                            <div
                              className={`px-4 py-[5px] flex items-center gap-2 w-fit text-sub_span text-black rounded-full !font-semibold bg-[#F03D361A] text-red-600`}
                            >
                              <span
                                className={`w-[10px] h-[10px] rounded-full ${
                                  user.is_active
                                    ? "bg-[#00D261]"
                                    : "bg-[#F03D36]"
                                } `}
                              ></span>
                              {user?.is_active ? "Active" : "Inactive"}
                            </div>
                          </td>
                          <td className="py-3 px-2 flex items-center gap-3 justify-end">
                            <button
                              title="Edit"
                              className="w-[16px] h-[16px]"
                              onClick={() =>
                                navigate(`/plans/edit-plan/${user?.id}`)
                              }
                            >
                              {EditIcon}
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlanList;
